// Loader — spinner circular animado (CSS puro) com tokens da paleta.
//
// SRP: só renderiza. Tamanho/label são props — não busca dado, não conhece o
// contexto da chamada. Quem decide "carregando" vs "vazio" é a página.
//
// A11y: role="status" + aria-live="polite" + aria-busy="true" pra leitores
// anunciarem o estado. `label` vira aria-label (default "Carregando").
import type { CSSProperties } from 'react';
import styles from './Loader.module.css';

export interface LoaderProps {
  /** Diâmetro em px. Default 50. */
  size?: number;
  /** Texto descritivo (aria-label). Default "Carregando". */
  label?: string;
  /** Override de classe pelo container externo. */
  className?: string;
}

export function Loader({ size = 50, label = 'Carregando', className }: LoaderProps) {
  const style = { '--loader-size': `${size}px` } as CSSProperties;
  return (
    <div role="status" aria-live="polite" aria-busy="true" aria-label={label} className={className}>
      <span className={styles.loader} aria-hidden="true" style={style} />
    </div>
  );
}

export default Loader;
